<!-- invalid BEM Naming Convention -->
<div class="promo__detail__container">
    <div class="overlay"></div>
    <div class="promo__detail">
        <app-header-promo-detail
            [data]="data"
            (isClose)="onClickClose()"
        ></app-header-promo-detail>
        <app-content-promo-detail
            [data]="data"
            (buy)="onClickBuy()"
        ></app-content-promo-detail>
        <app-footer-promo-detail
            [data]="data"
            (buy)="onClickBuy()"
        ></app-footer-promo-detail>
    </div>
</div>
